module.exports = __webpack_public_path__ + "static/media/empathai_chatbots.ae3b8d4c.png";